import { render, staticRenderFns } from "./AiInsightCard.vue?vue&type=template&id=3af0e165&scoped=true"
import script from "./AiInsightCard.vue?vue&type=script&lang=js"
export * from "./AiInsightCard.vue?vue&type=script&lang=js"
import style0 from "./AiInsightCard.vue?vue&type=style&index=0&id=3af0e165&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0e165",
  null
  
)

export default component.exports